import React from "react"
import styled from "styled-components"

const NavbarContentStyles = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: none;
  @media screen and (max-width: 768px) {
    margin-top: 1rem;
    overflow-x: scroll;
  }
`

const NavbarContent = ({ children }) => (
  <NavbarContentStyles>{children}</NavbarContentStyles>
)

export default NavbarContent
